import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';
import { RequestQueryPayload } from 'mongo-to-parse';
import { AppConfig } from 'src/app/app.config';
import { ConnectionService } from 'src/services/connection-service';
import { WindowRefService } from 'src/services/window-ref-service';

@Component({
  selector: 'hero-ingredient-list',
  imports: [AgGridModule, RouterModule],
  templateUrl: './hero-ingredient-list.component.html',
  standalone: true,
})
export class HeroIngredientListComponent {
  gridApi: GridApi;
  dataSource: any;
  window: any;
  components: any;
  ui: any = {};
  columnDefs: any;
  count: number;

  heroIngredientsCount: number;

  constructor(private router: Router,
              private conn: ConnectionService,
              public appConfig: AppConfig,
              windowRef: WindowRefService,
              private route: ActivatedRoute) {
    this.window = windowRef.nativeWindow;
  }

  ngOnInit(): void {
    this.listViewSetup();
  }

  listViewSetup(): any {
    this.ui = { grid: { rowModelType: 'infinite', pageSize: 100 } };
    this.setUpGrid();
  }

  setUpGrid(): void {
    this.dataSource = {
      rowCount: null,
      getRows: (params: any) => {
        this.loadMore(params)
          .then((data: Array<Table.HeroIngredient>) => {
            if (params.startRow === 0 && !data.length) this.gridApi.showNoRowsOverlay();
            else this.gridApi.hideOverlay();
            params.successCallback(data, data.length === this.ui.grid.pageSize ? -1 : params.startRow + data.length);
          });
      }
    }
    this.components = {
      loadingRenderer(params: any): any {
        if (params.value) return params.value;
        return '';
      },
    };
    this.columnDefs = [
      {
        headerName: 'id',
        field: 'objectId',
        pinned: 'left',
        cellRenderer: (params: any): any => {
          const url = this.router.url;
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = `<a class='col-xs-12 no-padder ellipsis' href='${url}/${params.value}'>${params.value}</a>`;
          return eDiv;
        },
        width: 100,
      },
      {
        headerName: 'edit',
        width: 50,
        cellRenderer: (params: any): any => {
          const url = this.router.url;
          const eDiv = this.window.document.createElement('div');
          const id = params.data?.objectId || params.value;
          eDiv.innerHTML = `<a class='fa fa-pencil-square-o' href='${url}/${id}/edit'></a>`;
          return eDiv;
        }
      },
      {
        headerName: 'name',
        field: 'nameLanguageString',
        cellRenderer: (params: any): any => {
          if (!params.data) return '';
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = params.value.en;
          return eDiv;
        },
        width: 200,
      },
      {
        headerName: 'description',
        field: 'descriptionLanguageString',
        cellRenderer: (params: any): any => {
          if (!params.data) return '';
          const eDiv = this.window.document.createElement('div');
          eDiv.innerHTML = params.value.en;
          return eDiv;
        },
        width: 300,
      },
      {
        headerName: 'priority',
        field: 'priority',
        width: 100,
      },
      {
        headerName: 'image',
        field: 'image',
        width: 200,
      },
    ];
  }

  async loadMore(params: any): Promise<any> {
    const requestPayload: RequestQueryPayload<Table.HeroIngredient> = {
      where: {},
      limit: this.ui.grid.pageSize,
      skip: params.startRow,
      ascending: 'createdAt',
      include: ['nameLanguageString', 'descriptionLanguageString'],
    };

    let heroIngredients: Array<Table.HeroIngredient>;
    [heroIngredients, this.heroIngredientsCount] = await Promise.all([
      this.conn.findHeroIngredients(requestPayload).then((items: any) => items.map((i: any) => JSON.parse(JSON.stringify(i)))),
      this.conn.countHeroIngredients(requestPayload),
    ]);
    return heroIngredients;
  }
  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.gridApi.setGridOption('defaultColDef', { width: 120 });
    this.gridApi.setGridOption('columnDefs', this.columnDefs);
    this.gridApi.setGridOption('cacheBlockSize', this.ui.grid.pageSize);
    this.gridApi.setGridOption('animateRows', true);
    this.gridApi.setGridOption('datasource', this.dataSource);
  }
}

